import { track } from '@/analytics/providers/TrackingApi';
import { ENVIRONMENT, FUNCTIONS_API_URL } from '@/config/settings';
import { store } from '@/store';
import { catchCommonErrors } from '@/api/helpers.js';

let tracked = [];

const TrackingEventConstants = {
  // Child Events
  ParentInviteStarted: 'Parent Invite Started',
  ShopEntered: 'Shop Entered',
  JoinClassStarted: 'Join Class Started',
  JoinClassFinished: 'Join Class Finished',
  QuizResumed: 'Quiz Resumed',
  DynamicQuizStarted: 'Dynamic Quiz Started',
  DynamicQuizFinished: 'Dynamic Quiz Finished'
  // Parent Events
};

const trackEvent = (action, isTrackOnce = false, values = {}) => {
  if (isTrackOnce && tracked.includes(action)) return;

  const state = store.getState();
  const { studentId, userId } = { ...state.user, ...state.school };

  if (!tracked.includes(action)) tracked.push(action);

  return track(
    action,
    {
      action,
      studentId,
      ...values
    },
    null,
    userId
  )?.catch(e => {
    catchCommonErrors(e);
  });
};

const postEvent = (action, data, userId) => {
  if (!userId) return;
  const body = {
    action,
    userId,
    properties: data
  };

  return fetch(`${FUNCTIONS_API_URL}/api/v3/users/${userId}/tracking-events`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      source: 'teacher_' + ENVIRONMENT
    }
  }).catch(e => {
    catchCommonErrors(e);
  });
};

const MetadataEvent = data => {
  const state = store.getState();
  const { userId } = { ...state.user };

  return fetch(`${FUNCTIONS_API_URL}/api/v3/users/${userId}/metadata`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      source: 'teacher_' + ENVIRONMENT
    }
  }).catch(e => {
    catchCommonErrors(e);
  });
};

const tracking = {
  track: (action, isTrackOnce, values) =>
    trackEvent(action, isTrackOnce, values),
  trackOverride: (action, data, userId) => postEvent(action, data, userId),
  metadata: (data, userid) => MetadataEvent(data, userid),
  eventNames: TrackingEventConstants
};

export default tracking;
